import moment from 'moment';

export const CERTIFICATES: {
    id: string;
    initial: string;
    color: string;
    type?: 'mcert' | 'consent' | null;
}[] = [
    {
        id: 'lai',
        initial: 'L',
        color: 'bg-darwin-accent-diagnosis-purple-800',
        type: 'mcert',
    },
    {
        id: 'fa',
        initial: 'F',
        color: 'bg-darwin-accent-investigations-ochre-800',
        type: 'mcert',
    },
    {
        id: 'tc',
        initial: 'T',
        color: 'bg-darwin-accent-green-800',
        type: 'mcert',
    },
    {
        id: '2de',
        initial: '2',
        color: 'bg-darwin-accent-medicines-pink-800',
        type: 'mcert',
    },
    {
        id: 'hivc',
        initial: 'H',
        color: 'bg-darwin-accent-medicines-pink-800',
        type: 'consent',
    },
    {
        id: 'prp',
        initial: 'PRP',
        color: 'bg-darwin-accent-diagnosis-purple-800',
        type: 'consent',
    },
    {
        id: 'lhr',
        initial: 'LHR',
        color: 'bg-darwin-accent-green-800',
        type: 'consent',
    },
    {
        id: 'pmfc',
        initial: 'P',
        color: 'bg-darwin-accent-diagnosis-purple-800',
        type: 'mcert',
    },
    {
        id: 'cp',
        initial: 'CP',
        color: 'bg-darwin-accent-investigations-ochre-800',
        type: 'consent',
    },
    {
        id: 'dc',
        initial: 'DC',
        color: 'bg-darwin-accent-medicines-pink-800',
        type: 'mcert',
    },
];

export const CUSTOM_CERT_ID = 'custom';
export const PREDEFINED_CERTIFICATES_IDS = [...CERTIFICATES.map((t) => t.id), CUSTOM_CERT_ID];

export const EKA_VARIABLE_CLASSLIST = 'ekavariable';

const today = moment(new Date()).format('YYYY-MM-DD');

export const CERTIFICATES_CONFIG: {
    [k: string]: { heading: string; template: string; name: string };
} = {
    lai: {
        name: 'Leave after illness',
        heading: `MEDICAL LEAVE CERTIFICATE`,
        template: `
        <br>
        I <strong class="ekavariable drName">{$drName}</strong>, after careful personal examination of the case hereby certify that <strong class="ekavariable ptName">{$ptName}</strong> <strong class="ekavariable ptAge">{$ptAge}</strong> is suffering from <strong class="ekavariable diagnosis"> <input placeholder="Diagnosis"/>  </strong> and I consider that a period of absence from duty from <strong
        class="ekavariable fromDate date"><input type="date" value="${today}" /></strong> to <strong
        class="ekavariable toDate date"><input type="date" value="${today}" /></strong> is absolutely necessary for the restoration of his/her health.
        <br>
        <br>
        <p>
            Dated : <strong class="ekavariable todayDate date"><input type="date" value="${today}" /></strong>
        </p>       
    
        `,
    },
    fa: {
        name: 'Fitness Adult',
        heading: `MEDICAL FITNESS CERTIFICATE`,
        template: `
        <br>
        I, <strong class="ekavariable drName">{$drName}</strong> Registered Medical Practitioner do hereby certify that we / I have carefully examined <strong class="ekavariable ptName">{$ptName}</strong> <strong class="ekavariable ptAge">{$ptAge}</strong>, and find that he / she recovered from his / her illness and is now fit to resume duties. We / I also certify that before arriving at this decision, we / I have examined the original medical certificate(s) and statement(s) of the case (or certified copies thereof) on which leave was granted or extended and have taken these into consideration in arriving at our / my decision.
        <br>
        <br>
        <p>
            Dated : <strong class="ekavariable todayDate date"><input type="date" value="${today}" /></strong>
        </p>      
        
        `,
    },
    tc: {
        name: 'Travel Certificate',
        heading: `TRAVEL CERTIFICATE`,
        template: `
        <br>
        I, <strong class="ekavariable drName">{$drName}</strong> hereby attest that <strong class="ekavariable ptName">{$ptName}</strong> <strong class="ekavariable ptAge">{$ptAge}</strong> is fit to travel. I deem the named person to be in good physical health and free of any severe or chronic illness such as pulmonary and/or respiratory ailments and is medically fit to travel.
        <br>
        <br>
        <p>
            Dated : <strong class="ekavariable todayDate date"><input type="date" value="${today}" /></strong>
        </p>         
        `,
    },
    '2de': {
        name: '2D ECHO',
        heading: '2D-ECHOCARDIOGRAPHY & COLOUR DOPPLER',
        template: `
        <p dir="ltr">Name: <span class="ekavariable ptName">{$ptName}</span><span class="space"> &nbsp;</span>Age: <span class="ekavariable ptAge">{$ptAge}</span><span class="space"> &nbsp;</span>Sex: <span class="ekavariable ptSex">{$ptSex}</span><span class="space"> &nbsp;</span>Id:&nbsp; &nbsp; &nbsp; &nbsp; date:&nbsp; <span class="ekavariable today">{$today}</span><span class="space">&nbsp;</span></p>
        <p dir="ltr"><strong>DIMENSION</strong></p>
        <table style="border-collapse: collapse; width: 101.759%;" border="1">
        <colgroup>
            <col style="width: 26.6941%;">
            <col style="width: 25.3454%;">
            <col style="width: 28.1829%;">
            <col style="width: 19.7775%;">
        </colgroup>
        <tbody>
            <tr>
                <td>IVS: <span class="ekavariable input">{$input}</span></td>
                <td>AO: <span class="ekavariable input">{$input}</span></td>
                <td>LVIDd:<span class="space"> <span class="ekavariable input">{$input}</span></span></td>
                <td>&nbsp;</td>
            </tr>
            <tr>
                <td>PW: <span class="ekavariable input">{$input}</span></td>
                <td>LA: <span class="ekavariable input">{$input}</span></td>
                <td>LVIDs: <span class="ekavariable input">{$input}</span></td>
                <td>LVEF:</td>
            </tr>
        </tbody>
        </table>
        <p dir="ltr"><strong>CHAMBERS</strong>: <em>NORMAL&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</em></p>
        <p dir="ltr"><strong>RWMA</strong>: <em>NIL</em></p>
        <p dir="ltr"><strong>LV FUNCTION</strong>: <em>NORMAL&nbsp;&nbsp;&nbsp;&nbsp;</em>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
        <p dir="ltr"><strong>VALVES</strong>: <em>NORMAL&nbsp; &nbsp;</em></p>
        <p dir="ltr"><strong>if abnormal</strong> :</p>
        <table style="border-collapse: collapse; width: 100%;" border="1">
        <colgroup>
            <col style="width: 50%;">
            <col style="width: 50%;">
        </colgroup>
        <tbody>
            <tr>
                <td>MV</td>
                <td>TR</td>
            </tr>
            <tr>
                <td>AV</td>
                <td>PV</td>
            </tr>
        </tbody>
        </table>
        <p dir="ltr"><strong>IAS</strong>: <em>INTACT&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</em>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
        <p dir="ltr"><strong>IVS</strong>:<em> INTACT</em></p>
        <p dir="ltr"><strong>IVC</strong>:&nbsp;</p>
        <p dir="ltr"><strong>CLOT/VEGETATIONS</strong>: <em>ABSENT</em></p>
        <p dir="ltr"><strong>PERICARDIUM</strong>:<em> NORMAL</em></p>
        <p dir="ltr"><strong>CONGENITAL HEART LESIONS</strong> :&nbsp; <em>NO E/O PDA/CoA&nbsp; </em></p>
        <p dir="ltr"><strong>DIASTOLIC FUNCTION</strong>: <em>NORMAL&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</em> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <strong>PAH</strong>: <em>NORMAL</em></p>
        <p dir="ltr"><strong>IMPRESSION</strong>: &nbsp;NORMAL 2D-ECHO.</p>
        <p dir="ltr"><strong>ADVICE</strong>:&nbsp;</p>
        <p>&nbsp;</p>
        `,
    },
    hivc: {
        name: 'HIV Consent',
        heading: 'CONSENT FORM FOR HIV TESTING AND PRE-TEST COUNSELLING',
        template: `<p style="text-align: right">
        <strong
          >Lab No: <span class="ekavariable input">{$input}</span
          ><span class="space"> &nbsp;</span></strong
        >
      </p>
      \n
      <p style="text-align: center">
        <strong><span class="space">Patient Information</span></strong>
      </p>
      \n
      <table
        style="
          border-collapse: collapse;
          width: 100%;
          height: 61.1952px;
          border-width: 1px;
          background-color: #ffffff;
          border-color: #ffffff;
        "
        border="1"
      >
        <colgroup>
          <col style="width: 50.0629%" />
          <col style="width: 49.9371%" />
        </colgroup>
        \n
        <tbody>
          \n
          <tr style="height: 22.3984px">
            \n
            <td
              style="
                height: 22.3984px;
                border-width: 1px;
                border-color: rgb(255, 255, 255);
              "
            >
              Name: <span class="ekavariable ptName">{$ptName}</span
              ><span class="space"> &nbsp;</span>
            </td>
            \n
            <td
              style="
                height: 22.3984px;
                border-width: 1px;
                border-color: rgb(255, 255, 255);
              "
            >
              Age: <span class="ekavariable ptAge">{$ptAge}</span
              ><span class="space"> &nbsp;</span>
            </td>
            \n
          </tr>
          \n
          <tr style="height: 22.3984px">
            \n
            <td
              style="
                height: 22.3984px;
                border-width: 1px;
                border-color: rgb(255, 255, 255);
              "
            >
              Gender: <span class="ekavariable ptSex">{$ptSex}</span
              ><span class="space"> &nbsp;</span>
            </td>
            \n
            <td
              style="
                height: 22.3984px;
                border-width: 1px;
                border-color: rgb(255, 255, 255);
              "
            >
              Mobile No: <span class="ekavariable input">{$input}</span
              ><span class="space"> &nbsp;</span>
            </td>
            \n
          </tr>
          \n
          <tr style="height: 16.3984px">
            \n
            <td
              style="
                height: 16.3984px;
                border-width: 1px;
                border-color: rgb(255, 255, 255);
              "
            >
              Physician Name: <span class="ekavariable drName">{$drName}</span
              ><span class="space"> &nbsp;</span>
            </td>
            \n
            <td
              style="
                height: 16.3984px;
                border-width: 1px;
                border-color: rgb(255, 255, 255);
              "
            >
              Reporting Centre: <span class="ekavariable input">{$input}</span
              ><span class="space"> &nbsp;</span>
            </td>
            \n
          </tr>
          \n
          <tr>
            \n
            <td style="border-width: 1px; border-color: rgb(255, 255, 255)">
              Address: <span class="ekavariable input">{$input}</span
              ><span class="space"> &nbsp;</span>
            </td>
            \n
            <td style="border-width: 1px; border-color: rgb(255, 255, 255)">
              &nbsp;
            </td>
            \n
          </tr>
          \n
        </tbody>
        \n
      </table>
      \n
      <p><strong>CONSENT:</strong></p>
      \n
      <p>
        I, the undersigned, provide my consent* to get my blood tested for HIV. The
        significance, relevant information and pre-test counselling has been provided
        to me in the language I best understand. Post-test counselling shall be done
        as per my treating physician's directions.
      </p>
      \n
      <p>
        I understand that my result shall be kept confidential. I authorize the
        following person / agency to collect the report on my behalf.
      </p>
      \n
      <table
        style="
          border-collapse: collapse;
          width: 100%;
          border-width: 1px;
          background-color: #ffffff;
          border-color: #ffffff;
        "
        border="1"
      >
        <colgroup>
          <col style="width: 50%" />
          <col style="width: 50%" />
        </colgroup>
        \n
        <tbody>
          \n
          <tr>
            \n
            <td style="border-width: 1px; border-color: rgb(255, 255, 255)">
              self:&nbsp;<span class="ekavariable input">{$input}</span
              ><span class="space"> &nbsp;</span>
            </td>
            \n
            <td style="border-width: 1px; border-color: rgb(255, 255, 255)">
              ref. Doctor: <span class="ekavariable input">{$input}</span
              ><span class="space"> &nbsp;</span>
            </td>
            \n
          </tr>
          \n
          <tr>
            \n
            <td style="border-width: 1px; border-color: rgb(255, 255, 255)">
              Ref. Agency: <span class="ekavariable input">{$input}</span
              ><span class="space"> &nbsp;</span>
            </td>
            \n
            <td style="border-width: 1px; border-color: rgb(255, 255, 255)">
              Next of kin: <span class="ekavariable input">{$input}</span
              ><span class="space"> &nbsp;</span>
            </td>
            \n
          </tr>
          \n
        </tbody>
        \n
      </table>
      \n
      <p style="text-align: right">
        Name: <span class="ekavariable ptName">{$ptName}</span
        ><span class="space"> &nbsp;</span>
      </p>
      \n
      <p style="text-align: right">
        <span class="space"
          >Signature of Patient: <span class="ekavariable ptSign">{$ptSign}</span
          ><span class="space"> &nbsp;</span></span
        >
      </p>
      \n
      <p style="text-align: left">
        <em
          ><span class="space"
            >*In case of minors, consent form to be signed by either of the Parents /
            legal Guardian</span
          ></em
        >
      </p>
      \n
      <p style="text-align: left">
        <em
          ><span class="space"
            >*In Adoption cases, consent form to be signed by Orphanage / NGO /
            Adopting Parents</span
          ></em
        >
      </p>
      \n
      <p style="text-align: left">
        <em
          ><span class="space"
            >*In case of incapacitated or hospitalised patients, consent to be signed
            by next of kin or doctor</span
          ></em
        >
      </p>
      \n
      <p style="text-align: left">&nbsp;</p>
      `,
    },
    prp: {
        name: 'PRP Consent',
        heading: 'CONSENT FORM FOR AUTOLOGOUS PLATELET RICH PLASMA (PRP)',
        template: `<p class="p1">&nbsp;</p>
        \n
        <p class="p2">
          Mr/Mrs./Miss<span class="ekavariable ptName">{$ptName}</span
          ><span class="space"> &nbsp;</span>
        </p>
        \n
        <p class="p2">
          Age:<span class="ekavariable ptAge">{$ptAge}</span
          ><span class="space"> &nbsp;</span
          ><span class="space">&nbsp;</span>&nbsp;Sex:<span
            class="Apple-converted-space"
          >
            <span class="ekavariable ptSex">{$ptSex}</span
            ><span class="space"> &nbsp;</span></span
          >Hospital ID: <span class="ekavariable input">{$input}</span
          ><span class="space"> &nbsp;</span
          ><span class="Apple-converted-space"
            >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            &nbsp;</span
          >
        </p>
        \n
        <p class="p2">
          Address: <span class="ekavariable input">{$input}</span
          ><span class="space"> &nbsp;</span>
        </p>
        \n
        <p class="p2">
          Phone No:<span class="ekavariable input">{$input}</span
          ><span class="space"> &nbsp;</span> Mobile:
          <span class="ekavariable input">{$input}</span
          ><span class="space"> &nbsp;</span>
        </p>
        \n
        <p class="p2">
          Email:<span class="ekavariable input">{$input}</span
          ><span class="space"> &nbsp;</span>
        </p>
        \n
        <p class="p2">
          Diagnosis:<span class="ekavariable input">{$input}</span
          ><span class="space"> &nbsp;</span>
        </p>
        \n
        <p class="p2">
          Name of the PROCEDURE:<span class="ekavariable input">{$input}</span
          ><span class="space"> &nbsp;</span>
        </p>
        \n
        <p class="p2">
          Date:<span class="ekavariable today">{$today}</span
          ><span class="space"> &nbsp;</span>
        </p>
        \n
        <p class="p2">
          INDICATION FOR PRP <span class="ekavariable input">{$input}</span
          ><span class="space"> &nbsp;</span>
        </p>
        \n
        <p class="p1"><strong>Procedure Details:</strong></p>
        \n
        <p class="p1">
          <strong
            ><span class="Apple-converted-space">&nbsp;</span>I HAVE BEEN INFORMED IN
            THE LANGUAGE I BEST UNDERSTAND THAT</strong
          >
        </p>
        \n
        <p class="p1">
          Platelet Rich Plasma (PRP) is an injection treatment whereby the patient’s own
          blood is centrifuged to separate out the platelet portion that is then
          injected back into the specific sites for the given indication above. It
          releases growth factors to stimulate new collagen production and to energize
          the cells into rejuvenating themselves. The same process is also done for the
          hair to reduce hair loss and improve the hair growth. It also helps in wound
          healing and improvement of scars.
        </p>
        \n
        <p class="p1">
          There are different methods for the preparation of PRP. The doctor has
          discussed with me regarding the pros and cons of the different methods and the
          available commercial kits.
        </p>
        \n
        <p class="p1">
          The total number of treatment sessions may vary among individuals. Exact
          number of sessions cannot be predicted. A minimum number of 3 to 6 sittings
          maybe required before I can appreciate any visible change. I have been
          explained about maintenance treatments that may be required after completion
          of treatment.<span class="Apple-converted-space">&nbsp;</span>
        </p>
        \n
        <p class="p1">
          No guarantee, warranty, or assurance has been made to me as to the results
          that may be obtained. On rare occasion there may be a patient who does not
          respond to treatment<span class="Apple-converted-space">&nbsp;</span>
        </p>
        \n
        <p class="p1">
          I was also informed about the other alternative methods as well as their
          benefits and disadvantages. I understand that for ideal results, this
          procedure can be combined with microneedling, lasers and chemical peels, etc.
        </p>
        \n
        <p class="p1"><strong>I AM ALSO INFORMED THAT</strong></p>
        \n
        <ul class="ul1">
          \n
          <li class="li1">
            Some side effects and complications may be experienced like pain, headache,
            stinging, mild to moderate swelling which may subside in 3 to 7 days,
            redness and heat, nausea, vomiting, dizziness and transient increase in
            sugar levels.
          </li>
          \n
          <li class="li1">
            Variable results are seen due to the patients’ lifestyle, medical profile,
            and age, the extent of wrinkling, extent of hair loss, smoking, sun damage,
            nutritional make-up, and genetic factors. The results depend on the platelet
            levels and the level of growth factors in these platelets, which vary from
            person to person.<span class="Apple-converted-space">&nbsp;</span>
          </li>
          \n
          <li class="li1">
            The procedure is not FDA approved for cosmetic indications and approved for
            wound regeneration.
          </li>
          \n
          <li class="li1">
            Topical, local or general anesthesia is required in few patients. I am ready
            to take the appropriate form of anesthesia.
          </li>
          \n
          <li class="li1">
            Pre and post procedure photographs will be taken which may be used for
            academic or scientific purposes.
          </li>
          \n
          <li class="li1">
            The results may be seen only after 4 to 6 weeks after this session.
          </li>
          \n
          <li class="li1">
            This is not a complete treatment for my ailment and other forms of
            treatments may be needed for optimum results.
          </li>
          \n
        </ul>
        \n
        <p class="p2">&nbsp;</p>
        \n
        <p class="p1"><strong>COST AND PAYMENT</strong></p>
        \n
        <p class="p1">
          I have been informed about the fees and the number of sessions / package. I
          shall abide by the same
        </p>
        \n
        <p class="p1">
          <strong
            >SIGNATURE OF PATIENT/ AUTHORIZED REPRESENTATIVE (in case of minor)
            <span class="ekavariable ptSign">{$ptSign}</span><span class="space"> &nbsp;</span></strong
          >
        </p>
        \n
        <p class="p1">
          <strong>Name:<span class="Apple-converted-space">&nbsp;</span></strong
          ><span class="ekavariable ptName">{$ptName}</span
          ><span class="space"
            >&nbsp; / <span class="ekavariable input">{$input}</span
            ><span class="space"> &nbsp;</span></span
          >
        </p>
        \n
        <table
          style="
            border-collapse: collapse;
            width: 100%;
            border-width: 1px;
            background-color: #ffffff;
            border-color: #ffffff;
          "
          border="1"
        >
          <colgroup>
            <col style="width: 50%" />
            <col style="width: 50%" />
          </colgroup>
          \n
          <tbody>
            \n
            <tr>
              \n
              <td style="border-width: 1px; border-color: rgb(255, 255, 255)">
                \n
                <p class="p1">
                  <strong
                    >SIGNATURE OF WITNESS<span class="ekavariable input">{$input}</span
                    ><span class="space"> &nbsp;</span></strong
                  >
                </p>
                \n
              </td>
              \n
              <td style="border-width: 1px; border-color: rgb(255, 255, 255)">
                \n
                <p class="p1">
                  <strong
                    >SIGNATURE OF OPERATING DOCTOR
                    <span class="ekavariable input">{$input}</span
                    ><span class="space"> &nbsp;</span></strong
                  >
                </p>
                \n
              </td>
              \n
            </tr>
            \n
            <tr>
              \n
              <td style="border-width: 1px; border-color: rgb(255, 255, 255)">
                \n
                <p class="p1">
                  <strong
                    >Name:<span class="Apple-converted-space">
                      <span class="ekavariable input">{$input}</span
                      ><span class="space"> &nbsp;</span>&nbsp;</span
                    ></strong
                  >
                </p>
                \n
              </td>
              \n
              <td style="border-width: 1px; border-color: rgb(255, 255, 255)">
                \n
                <p class="p1">
                  <strong
                    >Name:<span class="Apple-converted-space">
                      <span class="ekavariable drName">{$drName}</span
                      ><span class="space"> &nbsp;</span>&nbsp;</span
                    ></strong
                  >
                </p>
                \n
              </td>
              \n
            </tr>
            \n
          </tbody>
          \n
        </table>
        \n
        <table
          style="
            border-collapse: collapse;
            width: 100%;
            border-width: 1px;
            background-color: #ffffff;
            border-color: #ffffff;
          "
          border="1"
        >
          <colgroup>
            <col style="width: 33.2915%" />
            <col style="width: 33.2915%" />
            <col style="width: 33.2915%" />
          </colgroup>
          \n
          <tbody>
            \n
            <tr>
              \n
              <td style="border-width: 1px; border-color: rgb(255, 255, 255)">
                \n
                <p class="p1">
                  <strong
                    >Date:<span class="ekavariable today">{$today}</span
                    ><span class="space"> &nbsp;</span></strong
                  >
                </p>
                \n
              </td>
              \n
              <td style="border-width: 1px; border-color: rgb(255, 255, 255)">
                \n
                <p class="p1">
                  <strong
                    >Time:<span class="Apple-converted-space">
                      <span class="ekavariable input">{$input}</span
                      ><span class="space"> &nbsp;</span></span
                    ></strong
                  >
                </p>
                \n
              </td>
              \n
              <td style="border-width: 1px; border-color: rgb(255, 255, 255)">
                \n
                <p class="p1">
                  <strong
                    >Place:<span class="ekavariable input">{$input}</span
                    ><span class="space"> &nbsp;</span></strong
                  >
                </p>
                \n
              </td>
              \n
            </tr>
            \n
          </tbody>
          \n
        </table>
        `,
    },
    lhr: {
        name: 'Laser Hair Reduction',
        heading: 'Consent for Laser Hair Reduction',
        template: `<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>Name: Mrs./ Mr./ Miss <span class="ekavariable ptName">{$ptName}</span><span class="space">&nbsp; Age : <span class="ekavariable ptAge">{$ptAge}</span><span class="space">&nbsp; Sex: <span class="ekavariable ptSex">{$ptSex}</span><span class="space">&nbsp; Date: <span class="ekavariable today">{$today}</span><span class="space"> &nbsp;</span></span></span></span></p>\n<p><span class="space">Address: <span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></span></p>\n<table style="border-collapse: collapse; width: 100%; border-width: 1px; background-color: #ffffff; border-color: #FFFFFF;" border="1"><colgroup><col style="width: 50%;"><col style="width: 50%;"></colgroup>\n<tbody>\n<tr>\n<td style="border-width: 1px; border-color: rgb(255, 255, 255);">Hospital ID: <span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></td>\n<td style="border-width: 1px; border-color: rgb(255, 255, 255);">Phone Number: <span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></td>\n</tr>\n</tbody>\n</table>\n<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>I, <span class="ekavariable ptName">{$ptName}</span><span class="space"> &nbsp;</span> here by authorize <span class="ekavariable drName">{$drName}</span><span class="space"> &nbsp;</span> or his trained assistant to operate on myself or on <span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span>, who is my <span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span>(relation) for <span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span> Initial<span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span>Treatment Area: <span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span> Indications: <span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span>&nbsp;</p>\n<p>Machine Used: <span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></p>\n<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>Laser hair reduction involves using a noninvasive laser device for long term reduction of facial or body hair. This procedure requires more than one treatment session. Even after multiple sittings, 100% reduction [hair free skin] is not possible. The hair will reduce treatment in numbers and thickness. Maintenance treatments may be required after completion of treatment.</p>\n<p>The total number of treatment sessions may vary among individuals. Exact number of sessions cannot be predicted. Patients with darker skin may require a greater number of treatment sessions and may be more prone to adverse effects.</p>\n<p>Hair shafts may be expelled out during the 2-3 weeks following treatment and may mimic the appearance of regrowing hair. These may be left to fall out, or they may simply be shaved. If a patient develops growth in areas in distant regions other than the region treated, it could be due to underlying detectable or undetectable hormonal problem and if those areas are also to be covered by treatment, patient will have to bear the cost of treatment.</p>\n<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>I am aware of the following:</p>\n<ul>\n<li>\n<p>The <strong>adverse events </strong>like stinging or burning sensation, redness resembling a sunburn (The redness will typically subside in 1 to 6 weeks but could last longer), swelling (subsides in 1 to 2 weeks), skin darkening in the treated areas and will usually fade within 1 to 6 months (rare), skin lightening (It usually re-pigment in 1 to 6 months, but in rare cases could be permanent), blisters or scabs, infection, acneiform eruptions, scarring, allergic reactions and even risks or complications associated with this treatment that are not yet reported in the literature. <strong>Increased hair growth in or around the treated area </strong>is a very rare consequence of Laser Hair Removal (Reason not known). However, these hairs can also be reduced with same laser.</p>\n</li>\n<li>\n<p>The potential benefits of the proposed procedure and possible <strong>alternate procedures</strong> like other laser treatments, intense pulsed light therapy, electrolysis, shaving, waxing and plucking and taking no treatment at all.</p>\n</li>\n<li>\n<p>No <strong>guarantee</strong>, warranty, or assurance has been made to me as to the results that may be obtained and that for maximum and optimum results, several treatment sessions may be required spaced at varying intervals.</p>\n</li>\n<li>\n<p>I understand that <strong>variable results</strong> are seen due to the patients’ lifestyle, medical profile, hormonal status (I give consent for hormone work-up), age, and genetic factors.</p>\n</li>\n<li>\n<p>The need of regularity of treatments, <strong>multiple sessions</strong> or touch-ups and maintenance treatments in the future.</p>\n</li>\n<li>\n<p>The need of proper <strong>pre- and post- treatment care</strong>. (The instructions given should be strictly adhered to).</p>\n</li>\n<li>\n<p>The <strong>cost of treatment</strong> per sitting and the payment schedule. (I will be responsible for reimbursing the cost of the procedure as many of the procedures may not covered by insurance companies or companies).</p>\n</li>\n<li>\n<p>The sensation of the procedure and on occasion, use of topical, block, local or general <strong>anesthesia</strong>. (I give consent for the anesthesia.)</p>\n</li>\n</ul>\n<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>I consent to the <strong>taking of the photographs </strong>during the course of my procedure for the purpose of proper documentation, publications, presentations and post-operative assessment. I give consent for that.</p>\n<p>For the <strong>women of childbearing age</strong>: By signing below I indicate that I am not pregnant. Furthermore, I agree to keep the doctors informed should I become pregnant during the course of the treatment.</p>\n<p>I will inform the doctor of all current <strong>medications</strong> and change in the medications during the course of treatment.</p>\n<p>My <strong>medical history</strong> regarding active skin infection, impaired healing (e.g., keloid scar formers), and pregnancy.</p>\n<p>I am giving consent that if anything goes wrong during the procedure, I may be given any <strong>emergency treatment</strong> best suited to me, without asking for my prior permission.</p>\n<p>I further state that, I have carefully read and understood all the information provided in this form and with a fully conscious mind, I hereby give my written consent for the said procedure along with its involved risks.</p>\n<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p><strong>The procedure, the side effects and the risks involved have been explained to me in my native language.</strong> I hereby <strong>release</strong> <span class="ekavariable drName">{$drName}</span><span class="space"> &nbsp;</span> and its designated staff from liability associated with the above procedure.</p>\n<p>I have been <strong>informed</strong> about the <strong>fees and the number of sessions / packages</strong>. I shall abide by the same.</p>\n<p>&nbsp;</p>\n<table style="border-collapse: collapse; width: 100%; height: 67.1952px;" border="1"><colgroup><col style="width: 50%;"><col style="width: 50%;"></colgroup>\n<tbody>\n<tr style="height: 22.3984px;">\n<td style="height: 22.3984px;">\n<p>signature of the patient:&nbsp;</p>\n<p><span class="ekavariable ptSign">{$ptSign}</span></p>\n</td>\n<td style="height: 22.3984px;">signature of the guardian (for minors):&nbsp;<span class="ekavariable input">{$input}</span></td>\n</tr>\n<tr style="height: 22.3984px;">\n<td style="height: 22.3984px;">\n<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>Name and relationship with the Guardian<span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></p>\n</div>\n</div>\n</div>\n</td>\n<td style="height: 22.3984px;">\n<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>Date</p>\n<p><span class="ekavariable today">{$today}</span><span class="space"> &nbsp;</span></p>\n</div>\n</div>\n</div>\n</td>\n</tr>\n<tr style="height: 22.3984px;">\n<td style="height: 22.3984px;">\n<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>Witness 1</p>\n<p><span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></p>\n</div>\n</div>\n</div>\n</td>\n<td style="height: 22.3984px;">\n<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>Witness 2</p>\n<p><span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></p>\n</div>\n</div>\n</div>\n</td>\n</tr>\n</tbody>\n</table>\n<p>Doctor's Signature: <br> <span class=" docSign">{$docSign}</span><span class="space"> &nbsp;</span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>`,
    },
    cp: {
        name: 'Chemical peeling',
        heading: 'Consent for Chemical Peeling',
        template: `<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>Mr./Mrs./Miss: <span class="ekavariable ptName">{$ptName}</span><span class="space"> &nbsp;</span></p>\n<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>Age: <span class="ekavariable ptAge">{$ptAge}</span><span class="space">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Sex: <span class="ekavariable ptSex">{$ptSex}</span><span class="space">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span></span><span style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">Mobile: <span class="ekavariable input">{$input}</span><span class="space">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span></span><span style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">Date: <span class="ekavariable today">{$today}</span><span class="space"> &nbsp;</span></span></p>\n<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>Email: <span class="ekavariable input">{$input}</span><span class="space">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span></p>\n<p><span class="space">Address: <span class="ekavariable input">{$input}</span> &nbsp;</span></p>\n<p><span class="space"><strong>PROCEDURE:</strong> <span class="ekavariable input">{$input}</span> &nbsp;</span></p>\n<p><span class="space"><strong>TYPE OF CHEMICAL PEEL:</strong> <span class="ekavariable input">{$input}</span> &nbsp;</span></p>\n<p>&nbsp;</p>\n<p><span class="space">Procedure details :&nbsp;</span></p>\n<p><span class="space">I HAVE BEEN INFORMED IN THE LANGUAGE I BEST UNDERSTAND THAT</span></p>\n<ul>\n<li>\n<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>1. A chemical peel can be used to diminish the appearance of fine lines and wrinkles, improve texture/tone, reduce pore size, increase hydration and moisture retention, give skin a smoother appearance and diminish the appearance of hyper pigmentation. Layers of product are applied based on your unique skin composition and needs. Multiple treatments are required in order to obtain optimal results spaced 2-6 weeks apart. Due to variables such as age, condition of your skin, sun damage, smoking, skin care products, climate, life-style, and general health, you acknowledge that there are no guarantees, warranties or assurances that you will be satisfied with your results.</p>\n<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>&nbsp;</p>\n<p>2. Some contraindications for the treatment are Pregnancy, Lactation, Herpes Simplex (cold sores or fever blisters), Extensive sun or tanning, use of topical retinol products in the past 2 weeks, disturbed skin barrier and an allergy to aspirin.</p>\n<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>&nbsp;</p>\n<p>3. Most patients require a number of treatments over several months with gradual results occurring over this time. The total number of treatments and clinical results may vary between individuals.</p>\n<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>&nbsp;</p>\n<p>4. There may be some degree of discomfort, stinging, pin prick sensation, warmth, burning or itching at the time or after the procedure. It may cause my skin to appear pink and flaky like moderate sunburn and it may take a week or more before the skin returns to its normal appearance. However, some patients react differently.</p>\n<div class="page" title="Page 1">\n<div class="layoutArea">\n<div class="column">\n<p>&nbsp;</p>\n<p>5. Short-term effects may include Mild to moderate discomfort or pain, slight redness or swelling, sun sensitivity, skin sensitivity. These conditions usually self-resolve</p>\n<p>&nbsp;</p>\n<p>6. Rarely pigment changes, scarring, allergic reaction and secondary infection may happen.</p>\n<p>&nbsp;</p>\n<p>7. Variable results are seen due to the patients’ lifestyle, medical profile, age and the extent of severity of sagging which varies from person to person.</p>\n<p>&nbsp;</p>\n<p>8. All peeling agents may not be FDA approved for cosmetic indications.</p>\n<p>&nbsp;</p>\n<p>9. Pre and post procedure photographs will be taken which may be used for academic or scientific purposes.</p>\n<p>&nbsp;</p>\n<p>10. This is not a complete treatment for my ailment and other forms of treatments may be needed for optimum results.</p>\n<p>&nbsp;</p>\n<p>11. There are some other treatments which may help my concerns and those options were adequately discussed with me. I understand that for ideal results, this procedure can be combined with Micro needling, PRP, Laser, etc.</p>\n<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>&nbsp;</p>\n<p>I,<span class="ekavariable ptName">{$ptName}</span><span class="space"> &nbsp;</span>authorize&nbsp;<span class="ekavariable drName">{$drName}</span><span class="space"> &nbsp;</span> and her /his designated staff to perform procedure of Chemical Peeling. Further, my signature below indicates my consent for the treatment described and my agreement to comply with the requirements placed on me by this consent form.</p>\n<p>I have informed the doctor about my medical history regarding herpes, allergy, acne, keloids, diabetes, and autoimmune disease, treatment with anticoagulants, NSAIDS, blood thinners or corticosteroids etc. I am not pregnant or breast-feeding. In spite of this, I am aware that I may develop any allergy at any point. I give my consent to the doctor to take the necessary measures to treat my allergic reaction, if any develops. Before each treatment, I will inform the doctor if I have taken any new medications since my last treatment.</p>\n<p>I have been informed about the other alternative methods as well as their benefits and disadvantages.</p>\n<p>I understand that for ideal results, this procedure can be combined with micro needling, PRP, laser etc. No guarantee, warranty, or assurance has been made to me as to the results that may be obtained. I am also aware that follow-up treatments may be necessary for desired results.</p>\n<p>My questions regarding the procedure have been answered satisfactorily.<br>I hereby release <span class="ekavariable drName">{$drName}</span><span class="space"> &nbsp;</span>and her/his designated staff from any liability and side effects associated with above procedure. The payment and fee structure have been informed to me and I agree to abide by the same. I also agree to comply with the recommended aftercare instructions.</p>\n<p><strong>COST AND PAYMENT</strong></p>\n<p>I have been informed about the fees and the number of sessions / packages. I shall abide by the same</p>\n<p>&nbsp;</p>\n</div>\n</div>\n<div class="layoutArea">\n<div class="column">\n<p>&nbsp;</p>\n<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>SIGNATURE OF PATIENT/ AUTHORIZED REPRESENTATIVE (in case of minor): <span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></p>\n<p>Name: <span class="ekavariable ptName">{$ptName}</span><span class="space"> &nbsp;</span></p>\n</div>\n<div class="column">\n<table style="border-collapse: collapse; width: 100%;" border="1"><colgroup><col style="width: 50%;"><col style="width: 50%;"></colgroup>\n<tbody>\n<tr>\n<td>\n<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>SIGNATURE OF WITNESS: <span class="ekavariable ptSign">{$ptSign}</span><span class="space"> &nbsp;</span></p>\n<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>Name:<span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</td>\n<td>\n<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>SIGNATURE OF OPERATING DOCTOR: <br> <span class=" docSign">{$docSign}</span><span class="space"> &nbsp;</span></strong></span></p>\n</div>\n</div>\n</div>\n<div class="page" title="Page 2">\n<div class="layoutArea">\n<div class="column">\n<p>Name: <span class="ekavariable drName">{$drName}</span><span class="space"> &nbsp;</span></p>\n</div>\n</div>\n</div>\n&nbsp;</td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n<p>&nbsp;</p>\n<table style="border-collapse: collapse; width: 100%;" border="1"><colgroup><col style="width: 50%;"><col style="width: 50%;"></colgroup>\n<tbody>\n<tr>\n<td>Date: <span class="ekavariable today">{$today}</span><span class="space"> &nbsp;</span></td>\n<td>Place: <span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></td>\n</tr>\n</tbody>\n</table>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>`,
    },
    pmfc: {
        name: 'Pre-Op Medical Fitness Certificate',
        heading: 'Pre-Op Medical Fitness Certificate',
        template: `<p>This is to certify that <span class="ekavariable ptName">{$ptName}</span>, aged <span class="ekavariable ptAge">{$ptAge}</span>, <span class="ekavariable ptSex">{$ptSex}</span> has been medically examined by me on <span class="ekavariable date"><strong class="ekavariable todayDate date"><input value="${today}" type="date"></strong></span><span class="space">&nbsp;</span>and found to be fit for surgery.</p>
        <p>&nbsp;</p>
        <p><strong>Medical Examination Details:</strong></p>
        <table style="border-collapse: collapse; width: 100%; height: 350.734px; border-width: 0px; border-spacing: 0.1px;" border="1"><colgroup><col style="width: 28.0711%;"><col style="width: 72.025%;"></colgroup>
        <tbody>
        <tr style="height: 54.3906px;">
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;">
        <ul>
        <li>Medical Condition :</li>
        </ul>
        </td>
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;"><span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></td>
        </tr>
        <tr style="height: 54.3906px;">
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;">
        <ul>
        <li>Past Surgical History :</li>
        </ul>
        </td>
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;"><span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></td>
        </tr>
        <tr style="height: 54.3906px;">
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;">
        <ul>
        <li>Surgery Planned :</li>
        </ul>
        </td>
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;"><span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></td>
        </tr>
        <tr style="height: 54.3906px;">
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;">
        <ul>
        <li>Blood Pressure :</li>
        </ul>
        </td>
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;"><span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></td>
        </tr>
        <tr style="height: 54.3906px;">
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;">
        <ul>
        <li>Temperature :</li>
        </ul>
        </td>
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;"><span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></td>
        </tr>
        <tr style="height: 54.3906px;">
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;">
        <ul>
        <li>Heart Rate :</li>
        </ul>
        </td>
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;"><span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></td>
        </tr>
        <tr style="height: 54.3906px;">
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;">
        <ul>
        <li>Respiratory Rate :</li>
        </ul>
        </td>
        <td style="height: 54.3906px; border-width: 0px; padding: 0.1px;"><span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></td>
        </tr>
        <tr style="height: 23px;">
        <td style="height: 23px; border-width: 0px; padding: 0.1px;">
        <ul>
        <li>Examination findings :</li>
        </ul>
        </td>
        <td style="height: 23px; border-width: 0px; padding: 0.1px;"><span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></td>
        </tr>
        <tr style="height: 23px;">
        <td style="height: 23px; border-width: 0px; padding: 0.1px;">
        <ul>
        <li>Notes :</li>
        </ul>
        </td>
        <td style="height: 23px; border-width: 0px; padding: 0.1px;"><span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></td>
        </tr>
        </tbody>
        </table>
        <p>&nbsp;</p>
        <p>Based on the medical assessment conducted on&nbsp;<span class="ekavariable date"><strong class="ekavariable todayDate date"><input value="${today}" type="date"></strong></span>, <span class="ekavariable ptName">{$ptName}</span>is deemed fit for the proposed surgery.</p>
        <p>This certificate is valid for <strong>7 Days.</strong></p>`,
    },
    dc: {
        name: 'Discharge Certificate',
        heading: 'Discharge Certificate',
        template: `<p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;"><span lang="EN" style="font-size: 12.0pt; font-family: Poppins; mso-fareast-font-family: 'Times New Roman'; mso-font-kerning: 0pt; mso-ligatures: none; mso-ansi-language: EN; mso-fareast-language: EN-IN;">Name : <span class="ekavariable ptName">{$ptName}</span>,&nbsp; Age :<span class="ekavariable ptAge">{$ptAge}</span><span style="mso-tab-count: 1;">&nbsp;</span>Sex : <span class="ekavariable ptSex">{$ptSex}</span></span></p>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;"><span lang="EN" style="font-size: 12.0pt; font-family: Poppins; mso-fareast-font-family: 'Times New Roman'; mso-font-kerning: 0pt; mso-ligatures: none; mso-ansi-language: EN; mso-fareast-language: EN-IN;">Address : <span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></span></p>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;"><span lang="EN" style="font-size: 12.0pt; font-family: Poppins; mso-fareast-font-family: 'Times New Roman'; mso-font-kerning: 0pt; mso-ligatures: none; mso-ansi-language: EN; mso-fareast-language: EN-IN;">Patient ID :<span style="mso-spacerun: yes;">&nbsp;<span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span></span></p>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;"><span lang="EN" style="font-size: 12.0pt; font-family: Poppins; mso-fareast-font-family: 'Times New Roman'; mso-font-kerning: 0pt; mso-ligatures: none; mso-ansi-language: EN; mso-fareast-language: EN-IN;">DOA : <span class="ekavariable date"><strong class="ekavariable todayDate date"><input value="${today}" type="date"></strong></span><span class="space"> &nbsp;</span></span><span lang="EN" style="font-size: 12.0pt; font-family: Poppins; mso-fareast-font-family: 'Times New Roman'; mso-font-kerning: 0pt; mso-ligatures: none; mso-ansi-language: EN; mso-fareast-language: EN-IN;"><span style="mso-spacerun: yes;">&nbsp; &nbsp; &nbsp;</span>DOD : <span class="ekavariable date"><strong class="ekavariable todayDate date"><span class="ekavariable date"><strong class="ekavariable todayDate date"><input value="${today}" type="date"></strong></span><span class="space"> &nbsp;</span></strong></span></span></p>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;"><br><span style="font-family: Poppins;"><strong>Diagnosis : <span class="ekavariable input">{$input}</span><span class="space"> &nbsp;</span></strong></span></p>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;">&nbsp;</p>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;"><span style="font-family: Poppins;"><strong>Presenting Complaints:&nbsp;</strong></span></p>
                  <table style="border-collapse: collapse; width: 99.9669%; border-width: 0px;" border="1"><colgroup><col style="width: 100%;"></colgroup>
                  <tbody>
                  <tr>
                  <td style="border-width: 0px;">
                  <ul>
                  <li>&nbsp;</li>
                  </ul>
                  </td>
                  </tr>
                  </tbody>
                  </table>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;">&nbsp;</p>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;"><span style="font-family: Poppins;"><strong><span class="space">Course in Hospital :</span></strong></span></p>
                  <table style="border-collapse: collapse; width: 99.9669%; border-width: 0px;" border="1"><colgroup><col style="width: 100%;"></colgroup>
                  <tbody>
                  <tr>
                  <td style="border-width: 0px;">&nbsp;</td>
                  </tr>
                  </tbody>
                  </table>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;"><span style="font-family: Poppins;"><strong><span class="space">&nbsp;&nbsp;</span></strong></span></p>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;"><span style="font-family: Poppins;"><strong>Medications</strong> <strong>given</strong> <strong>in Hospital :</strong></span></p>
                  <table style="border-collapse: collapse; width: 100.054%; height: 111.979px;" border="1"><colgroup><col style="width: 19.9561%;"><col style="width: 19.9561%;"><col style="width: 19.9561%;"><col style="width: 19.9561%;"><col style="width: 19.9561%;"></colgroup>
                  <tbody>
                  <tr style="height: 22.3958px;">
                  <td style="height: 22.3958px; text-align: center;"><strong>Medicine Name</strong></td>
                  <td style="height: 22.3958px; text-align: center;"><strong>Dose</strong></td>
                  <td style="height: 22.3958px; text-align: center;"><strong>Frequency</strong></td>
                  <td style="height: 22.3958px; text-align: center;"><strong>Timing</strong></td>
                  <td style="height: 22.3958px; text-align: center;"><strong>Instructions</strong></td>
                  </tr>
                  <tr style="height: 22.3958px; text-align: center;">
                  <td style="height: 22.3958px;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  </tr>
                  <tr style="height: 22.3958px; text-align: center;">
                  <td style="height: 22.3958px;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  </tr>
                  <tr style="height: 22.3958px;">
                  <td style="text-align: center; height: 22.3958px;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  </tr>
                  </tbody>
                  </table>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;">&nbsp;</p>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;"><span style="font-family: Poppins;"><strong>Surgical/Procedural Notes :</strong></span></p>
                  <table style="border-collapse: collapse; width: 100.054%; border-width: 0px; height: 22.3958px;" border="1"><colgroup><col style="width: 99.7817%;"></colgroup>
                  <tbody>
                  <tr style="height: 22.3958px;">
                  <td style="border-width: 0px; height: 22.3958px;">&nbsp;</td>
                  </tr>
                  </tbody>
                  </table>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;">&nbsp;</p>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;"><strong><span style="font-family: Poppins;">Advice </span>:</strong></p>
                  <table style="border-collapse: collapse; width: 99.9669%; border-width: 0px;" border="1"><colgroup><col style="width: 100%;"></colgroup>
                  <tbody>
                  <tr>
                  <td style="border-width: 0px;">
                  <ul>
                  <li>&nbsp;</li>
                  </ul>
                  </td>
                  </tr>
                  </tbody>
                  </table>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;">&nbsp;</p>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;"><span style="font-family: Poppins;"><strong>Treatment Advised :</strong></span></p>
                  <table style="border-collapse: collapse; width: 100.054%; height: 111.979px;" border="1"><colgroup><col style="width: 19.9561%;"><col style="width: 19.9561%;"><col style="width: 19.9561%;"><col style="width: 19.9561%;"><col style="width: 19.9561%;"></colgroup>
                  <tbody>
                  <tr style="height: 22.3958px;">
                  <td style="height: 22.3958px; text-align: center;"><strong>Medicine Name</strong></td>
                  <td style="height: 22.3958px; text-align: center;"><strong>Dose</strong></td>
                  <td style="height: 22.3958px; text-align: center;"><strong>Frequency</strong></td>
                  <td style="height: 22.3958px; text-align: center;"><strong>Timing</strong></td>
                  <td style="height: 22.3958px; text-align: center;"><strong>Instructions</strong></td>
                  </tr>
                  <tr style="height: 22.3958px; text-align: center;">
                  <td style="height: 22.3958px;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  </tr>
                  <tr style="height: 22.3958px; text-align: center;">
                  <td style="height: 22.3958px;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  </tr>
                  <tr style="height: 22.3958px;">
                  <td style="text-align: center; height: 22.3958px;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  <td style="height: 22.3958px; text-align: center;">&nbsp;</td>
                  </tr>
                  </tbody>
                  </table>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;">&nbsp;</p>
                  <p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal;"><span style="font-family: Poppins;"><strong>Follow Up : &nbsp;<span class="ekavariable input">{$input}</span><span class="space"> &nbsp;<span class="ekavariable date"><strong class="ekavariable todayDate date"><input value="${today}" type="date"></strong></span><span class="space"> &nbsp;</span></span></strong></span></p>`,
    },
};
